import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LanguageRedirect = ({ lang }) => {
    const { i18n } = useTranslation();
    const navigate = useNavigate();

    useEffect(() => {
        // 1. Change the language in i18next
        i18n.changeLanguage(lang);

        // 2. Save it to localStorage
        localStorage.setItem('selectedLanguage', lang);

        // 3. Redirect the user to the default home page ("/")
        // We use replace: true so they don't get stuck in a "back button" loop
        navigate('/', { replace: true });
    }, [lang, i18n, navigate]);

    // Render nothing while the redirect happens instantly
    return null;
};

export default LanguageRedirect;